import React from 'react';
import type { DropdownIndicatorProps } from 'react-select';
import { components } from 'react-select';

import classnames from 'classnames/bind';

import styles from './DropdownIndicatorBase.module.scss';

const cx = classnames.bind(styles);

function DropdownIndicatorBase<T, IsMulti extends boolean>({
    children,
    ...props
}: DropdownIndicatorProps<T, IsMulti>) {
    return (
        <components.DropdownIndicator
            className={cx('dropdown-indicator-base', {
                'is-open': props.selectProps.menuIsOpen,
                'is-disabled': props.selectProps.isDisabled,
            })}
            {...props}
        >
            <div className={cx('icon-wrapper')}>
                <svg
                    className={cx('dropdown-icon')}
                    xmlns="http://www.w3.org/2000/svg"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="m6 9 6 6 6-6" />
                </svg>
            </div>
        </components.DropdownIndicator>
    );
}

export default DropdownIndicatorBase;
